import { render, staticRenderFns } from "./maintenrecordfrm.vue?vue&type=template&id=33041ca3"
import script from "./maintenrecordfrm.vue?vue&type=script&lang=js"
export * from "./maintenrecordfrm.vue?vue&type=script&lang=js"
import style0 from "./maintenrecordfrm.vue?vue&type=style&index=0&id=33041ca3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports